// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"c157aa44","238":"f504117e","239":"51f6d33e","361":"b1fc6c1b","384":"3a98381a","396":"b66d7688","453":"46944618","455":"eb5d9332","568":"94292c62","829":"32a16eb7","977":"18bb133e"}[chunkId] + ".chunk.js";
};